/* eslint-disable no-unused-vars */
import React from 'react';
// import { Link as RouterLink } from 'react-router-dom';
// import { Link as RouterLink, useNavigate } from 'react-router-dom';
// import * as Yup from 'yup';
// import { Formik } from 'formik';
import {
  // Box,
  // Button,
  // Checkbox,
  Container,
  // FormHelperText,
  // Link,
  // TextField,
  // Typography,
  makeStyles,
  Grid
} from '@material-ui/core';
import { KycFormFields } from "./KycFormfields";
import Page from '../../components/Page';
import Navbar from '../GetStarted/Navbar';
import NavbarLower from '../GetStarted/NavbarLower';
import Footer from '../pages/Footer';
import MainMenu from '../GetStarted/MainMenu';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    // height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

export const KycForm = () => {
  const classes = useStyles();
  // const navigate = useNavigate();

  return (
    <div>
      <NavbarLower/>
      <KycFormFields />
      <Footer/>
    </div>
  );
};

export default KycForm;
